import { makeStyles } from "@material-ui/core";

const decompteValidationUseStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    borderRadius: 8,
    marginTop: "1%",
    boxShadow:
      "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
  },
  btn: {
    margin: "1% 0.25%",
    fontWeight: 600,
  },
  pageHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },
  filterCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: "1px solid #dbe3ef",
    borderRadius: 10,
    boxShadow: "0 4px 14px rgba(15, 23, 42, 0.05)",
  },
  tableCard: {
    padding: theme.spacing(2),
    border: "1px solid #dbe3ef",
    borderRadius: 10,
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
  },
  tableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  gridWrapper: {
    height: 640,
    width: "100%",
  },
  dataGrid: {
    border: "0 !important",
    color: "#334155",
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#f4f7fb",
      borderBottom: "1px solid #dce6f3",
      color: "#29476f",
      fontWeight: 700,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      whiteSpace: "normal",
      lineHeight: 1.25,
    },
    "& .MuiDataGrid-row": {
      minHeight: "56px !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#f8fbff",
    },
    "& .MuiDataGrid-cell": {
      alignItems: "center",
      display: "flex",
      minHeight: "56px !important",
      paddingTop: "4px",
      paddingBottom: "4px",
      whiteSpace: "normal",
      lineHeight: 1.4,
      borderColor: "#edf1f7",
      overflow: "visible",
    },
    "& .MuiDataGrid-cellContent": {
      width: "100%",
      whiteSpace: "normal",
      lineHeight: 1.4,
      overflowWrap: "anywhere",
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "1px solid #dce6f3",
    },
  },
  detailDialog: {
    width: "99%",
    height: "99%",
    justifyContent: "center",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: 20,
    fontSize: 12,
  },
  detailDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    flexWrap: "wrap",
  },
  detailDialogActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between !important",
    gap: theme.spacing(2),
    padding: theme.spacing(1, 3),
    flexWrap: "wrap",
  },
  dialogScrollNotice: {
    color: "red",
    fontSize: 12,
    flex: "1 1 420px",
  },
  dialogActionButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(3),
    flex: "1 1 auto",
  },
  detailHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },
  detailCard: {
    padding: theme.spacing(2),
    border: "1px solid #dbe3ef",
    borderRadius: 10,
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
  },
  fieldset: {
    minWidth: 0,
    marginTop: 10,
    padding: 10,
    width: "94vw",
    maxWidth: "94vw",
    overflowX: "auto",
    border: "1px solid #d7e1f3",
    borderRadius: 10,
    backgroundColor: "#fff",
    color: "#1976d2",
    fontSize: 20,
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)",
    "& legend": {
      padding: "0 10px",
      color: "#2f5ca3",
      fontWeight: 700,
      letterSpacing: "0.2px",
    },
  },
  tableContainer: {
    width: "100%",
    maxWidth: "90.88vw",
    maxHeight: "60vh",
    overflowX: "auto",
    border: "1px solid #d7e1f3",
    borderRadius: 6,
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      width: 10,
      height: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#eef3f8",
      borderRadius: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#7f9fbd",
      border: "2px solid #eef3f8",
      borderRadius: 8,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#526f8c",
    },
  },
  detailTable: {
    borderCollapse: "separate",
    borderSpacing: 0,
    "& .MuiTableCell-root": {
      fontSize: 12,
      whiteSpace: "nowrap",
      transition: "background-color 140ms ease, color 140ms ease",
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      backgroundColor: "#eff6ff",
      color: "#0f4c81",
      textAlign: "center",
      fontWeight: 700,
      borderBottom: "1px solid #c9d9e8",
      zIndex: 3,
    },
    "& .MuiTableHead-root .MuiTableRow-root:first-child .MuiTableCell-root": {
      top: 0,
      height: 42,
    },
    "& .MuiTableHead-root .MuiTableRow-root:nth-of-type(2) .MuiTableCell-root":
      {
        top: 42,
        height: 42,
        boxShadow: "0 2px 3px rgba(15, 23, 42, 0.08)",
      },
    "& .MuiTableCell-body": {
      color: "#334155",
      fontSize: 12,
    },
    "& .MuiTableBody-root > .MuiTableRow-root:nth-of-type(odd)": {
      backgroundColor: "#ffffffdb",
    },
    "& .MuiTableBody-root > .MuiTableRow-root:hover": {
      backgroundColor: "#eaf3fc",
    },
    "& .MuiTableFooter-root .MuiTableCell-root": {
      backgroundColor: "#f8fafc",
      color: "#1f3f66",
      fontWeight: 700,
      borderTop: "2px solid #d7e1f3",
    },
  },
  transportGroupRow: {
    cursor: "pointer",
    backgroundColor: "#edf5ff",
    outline: "none",
    "& .MuiTableCell-root": {
      color: "#0f4c81",
      borderTop: "1px solid #d7e1f3",
      borderBottom: "1px solid #d7e1f3",
      transition: "background-color 140ms ease",
    },
    "&:hover .MuiTableCell-root, &:focus .MuiTableCell-root": {
      backgroundColor: "#dfeefa",
    },
    "&:focus-visible .MuiTableCell-root": {
      boxShadow: "inset 0 0 0 2px #1976d2",
    },
  },
  actionBar: {
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderTop: "1px solid #dbe3ef",
    backgroundColor: "#fff",
    flexWrap: "wrap",
  },
  scrollNotice: {
    color: "#b42318",
    fontSize: 13,
    fontWeight: 600,
  },
}));

export default decompteValidationUseStyles;
